'use client';

import { c as _c } from "react/compiler-runtime";
import { atom, useSetAtom } from 'jotai';
import type { PropsWithChildren } from 'react';
import { useEffect, useSyncExternalStore } from 'react';
import type { MediaState, MediaStateKey } from './media-state-store';
import { mediaStateStore, SERVER_MEDIA_STATE } from './media-state-store';
export type { MediaState, MediaStateKey } from './media-state-store';
export function useMediaState(key) {
  const $ = _c(4);
  let t0;
  if ($[0] !== key) {
    t0 = mediaStateStore.getKeySnapshot(key);
    $[0] = key;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== key) {
    t1 = mediaStateStore.getServerKeySnapshot(key);
    $[2] = key;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useSyncExternalStore(mediaStateStore.subscribe, t0, t1);
}
export function useClientMediaState(key) {
  const $ = _c(2);
  let t0;
  if ($[0] !== key) {
    t0 = mediaStateStore.getClientKeySnapshot(key);
    $[0] = key;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useSyncExternalStore(mediaStateStore.subscribe, t0, mediaStateStore.getServerClientKeySnapshot);
}
export const mediaStateAtom = atom<MediaState>(SERVER_MEDIA_STATE);
mediaStateAtom.debugLabel = 'mediaStateAtom';
export const MediaStateProvider = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  const setMediaState = useSetAtom(mediaStateAtom);
  const mediaState = useSyncExternalStore(mediaStateStore.subscribe, mediaStateStore.getSnapshot, mediaStateStore.getServerSnapshot);
  let t1;
  let t2;
  if ($[0] !== mediaState || $[1] !== setMediaState) {
    t1 = () => {
      setMediaState(mediaState);
    };
    t2 = [mediaState, setMediaState];
    $[0] = mediaState;
    $[1] = setMediaState;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return children;
};